import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import service1 from '../assets/service1.jpg';
import service2 from '../assets/service2.jpg';
import service3 from '../assets/service3.jpg';
import service4 from '../assets/service4.jpg';
import service5 from '../assets/service5.jpeg';
import service6 from '../assets/service6.jpeg';
import service7 from '../assets/service7.jpeg';
import service8 from '../assets/service8.jpeg';
import service9 from '../assets/service9.jpeg';
import '../styles/pages.css';

const services = [
  {
    title: 'Data Centre and Cloud Solutions',
    points: [
      'Complete data center setup including server infrastructure, power management, cooling systems, and enterprise-grade reliability.',
      'We design and implement data center solutions that provide maximum uptime, scalability, and efficiency for mission-critical operations.'
    ],
    link: '/services/data-centre',
    img: service1,
    alt: 'Data Centre Solutions'
  },
  {
    title: 'Network Solutions',
    points: [
      'Internal network setup, secure connectivity, firewalls, and access control. Building robust and secure network infrastructure.',
      "Our network solutions ensure seamless communication, data transfer, and security across your organization's IT environment."
    ],
    link: '/services/network',
    img: service2,
    alt: 'Network Solutions'
  },
  {
    title: 'Security Services',
    points: [
      'Cloud services, data storage & backup solutions, cybersecurity implementation, and secure access management.',
      'Protect your data and ensure business continuity with our comprehensive storage, security, and cloud infrastructure solutions.'
    ],
    link: '/services/security',
    img: service3,
    alt: 'Storage, Security & Cloud'
  },
  {
    title: 'IT Hardware Solutions',
    points: [
      'Enterprise-grade laptops, desktops, servers, and workstations. Complete procurement and deployment services for organizations of all sizes.',
      'We provide world class hardware solutions from renowned OEMs ensuring reliability, performance, scalability and support for your business needs.'
    ],
    link: '/services/hardware',
    img: service4,
    alt: 'IT Hardware'
  },
  {
    title: 'Managed IT Support Services',
    points: [
      'Managed IT Support is a strategic partnership where we proactively monitor, manage, and maintain your entire IT ecosystem — including servers, networks, endpoints, cloud systems, and security infrastructure.',
      'Instead of reacting to problems, we prevent them before they impact your operations.'
    ],
    link: '/services/managed-it',
    img: service5,
    alt: 'Managed IT Support Services'
  },
  {
    title: 'Storage Solutions',
    points: [
      'We deliver secure, scalable, and high-performance storage solutions designed to meet the growing data needs of modern enterprises.',
      'From on-premise storage systems to hybrid and cloud-integrated architectures, we ensure reliable data availability, optimized performance, and business continuity.'
    ],
    link: '/services/storage',
    img: service6,
    alt: 'Storage Solutions'
  },
  {
    title: 'Digital Workspace Solutions',
    points: [
      'We enable organizations to create modern, secure, and collaborative digital workplaces that enhance productivity and flexibility.',
      'Our digital workspace solutions empower employees to work seamlessly from anywhere while maintaining enterprise-grade security.'
    ],
    link: '/services/digital-workspace',
    img: service7,
    alt: 'Digital Workspace Solutions'
  },
  {
    title: 'Hybrid Workspace & AV Solutions',
    points: [
      'We design and implement intelligent hybrid workspace and audio-visual (AV) solutions that enhance collaboration between in-office and remote teams.',
      'Our solutions integrate advanced communication technologies to ensure seamless, high-quality interactions.'
    ],
    link: '/services/hybrid-workspace',
    img: service8,
    alt: 'Hybrid Workspace & AV Solutions'
  },
  {
    title: 'Financial Services',
    points: [
      'We provide flexible financial solutions that help organizations invest in technology without heavy upfront capital expenditure.',
      'Our financial services are designed to support IT procurement and infrastructure deployment with structured, business-friendly options.'
    ],
    link: '/services/financial',
    img: service9,
    alt: 'Financial Services'
  }
];

function Services() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [hash]);

  return (
    <div>
      <section className="hero">
        <div className="container">
          <h1>Our Services & Solutions</h1>
          <p>Comprehensive IT infrastructure solutions for your business</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {services.map((service) => (
            <div key={service.link} id={service.link.split('/').pop()} className="service-item">
              <div className="content-grid">
                <div className="content-text">
                  <h2 style={{ color: 'var(--primary)', marginBottom: '20px' }}>{service.title}</h2>
                  <ul className="overview-list">
                    {service.points.map((point, i) => (
                      <li key={i}>{point}</li>
                    ))}
                  </ul>
                  <Link to={service.link}>
                    <button className="btn btn-primary">Learn More</button>
                  </Link>
                </div>
                <div>
                  <img src={service.img} alt={service.alt} style={{ width: '100%', borderRadius: '10px' }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Services;
